import _ from 'lodash';
import HomeIcon from '@material-ui/icons/Home';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { SET_FINANCES, SET_GLOBAL_FINANCES } from '../../actions/types/index';
import { ORDER_CANCELED_LABEL, ORDER_SHOP_CANCELED_LABEL, ORDER_MISSED_LABEL } from 'src/constants';

export const getBottomNavigationData = data => {
  const newData = [];
  _.map(data, (e, key) => {
    newData.push({
      label: e,
      icon: key === 1 ? <AccountBalanceIcon /> : <HomeIcon />
    });
  });
  return newData;
};

export const getBottomNavigationComponentSize = numberOfItems => {
  let classNameBottomNavigation = 'col-sm-4 col-md-3 col-lg-2';
  if (numberOfItems > 1) {
    classNameBottomNavigation = 'col-sm-6 col-md-5 col-lg-4 col-xl-3';
  }
  return classNameBottomNavigation;
};

export const initializeFinance = async (isAllShops, component) => {
  const { dateRange } = component.state;
  if (isAllShops) {
    await component.props.setFinances(dateRange, SET_GLOBAL_FINANCES, component.props.shops, isAllShops);
    component.props.setSelectionFinanceEntity('global');
  } else {
    await component.props.setFinances(dateRange, SET_FINANCES, component.props.shops, isAllShops);
    component.props.setSelectionFinanceEntity('shop');
  }
  component.setState({ isLoading: false });
};

export const onChangeSelection = (component, e, value, valueTab) => {
  e.preventDefault();
  component.props.setSelectionFinance({ graph: value, tab: valueTab });
};

export const onChangeData = (component, e, value) => {
  e.preventDefault();
  component.props.setSelectionFinanceEntity(value ? 'global' : 'shop');
};

export const handleClick = (component, event) => {
  component.setState({ anchorEl: event.currentTarget });
};

export const handleClickYear = (component, event) => {
  component.setState({ anchorElYear: event.currentTarget });
};

export const handleClose = component => {
  component.setState(prevState => {
    return {
      anchorEl: null,
      periode: prevState.periode,
      anchorElYear: null,
      currentYear: prevState.currentYear
    };
  });
};

export const handleUpdateYear = (component, e) => {
  component.setState({
    currentYear: e,
    anchorElYear: null,
    periode: 'Selectionnez une période'
  });
};

export const onSelectDate = async (component, dateRange) => {
  const { isAllShops } = component.props;
  component.setState({
    dateRange,
    isLoadingDate: true
  });
  await component.props.setFinances(dateRange, SET_FINANCES, component.props.shops, component.props.isAllShops);
  await component.props.setFinances(dateRange, SET_GLOBAL_FINANCES, component.props.shops, component.props.isAllShops);
  await component.props.getFinishedOrders(null, dateRange, true, isAllShops);
  component.setState({
    dateRange,
    isLoadingDate: false
  });
};

export const calculateTotalTabForShop = async (billing, shopBilling, previousPeriod, shopId) => {
  const totalShopTab = {
    CA: 0,
    nbCmd: 0,
    moy: 0,
    rate: 0,
    canceledCmd: 0,
    missedCmd: 0,
  };
  const previousCA = await calculateCAThroughDateRange(billing, previousPeriod, shopId)
  const totalPreviousCA = await calculateCAThroughDateRange(billing, previousPeriod)
  for (const shopId in shopBilling) {
    const {
      priceOrder: price = 0,
    } = shopBilling[shopId];
    totalShopTab.CA += price;
    totalShopTab.nbCmd += 1;
    totalShopTab.moy = totalShopTab.CA / totalShopTab.nbCmd || 0;
    totalShopTab.rate = previousCA !== 0 ? (((totalShopTab.CA - previousCA) / previousCA) * 100) : 0;
    totalShopTab.previousCA = previousCA
    totalShopTab.totalPreviousCA = totalPreviousCA
  }
  return totalShopTab;
}

export const calculateCost = (organize, tab, price, priceCost) => {
  organize.cumulDaily += price;
  tab[0].cost += price;
  tab[1].cost += priceCost;
  tab[3].cost += 1;
};

export const calculateCAThroughDateRange = async (billing, dateRange, shopId) => {
  let totalCA = 0;
  try {
    const firstDate = dateRange.startDate;
    const lastDate = dateRange.endDate;
    const groupedBilling = {};
    if (shopId) {
      billing?.forEach(bill => {
        if (!groupedBilling[bill.shopId]) {
          groupedBilling[bill.shopId] = [];
        }
        groupedBilling[bill.shopId].push(bill);
      });
    }
    const shopBilling = shopId ? groupedBilling[shopId] : billing;
    if (shopBilling) {
      shopBilling.forEach(commande => {
        const {
          priceOrder: price = 0,
          dateOrder: orderDate = '',
        } = commande;
        const orderDateObj = new Date(orderDate);
        if (orderDateObj > firstDate && orderDateObj < lastDate && price !== 0) {
          totalCA += price;
        }
      }
      )
    }
  } catch (error) {
    console.error(error);
  }
  return totalCA;
}

export const calculatePreviousPeriod = (dateRange) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const startDate = new Date(dateRange.startDate);
  const endDate = new Date(dateRange.endDate);

  const daysDifference = Math.round((endDate - startDate) / oneDay);
  const offset = daysDifference;

  const previousPeriodStartDate = new Date(startDate.getTime() - offset * oneDay);
  const previousPeriodEndDate = new Date(endDate.getTime() - offset * oneDay);

  return {
    startDate: previousPeriodStartDate,
    endDate: previousPeriodEndDate
  };
};

export function calculateFinanceData(seedData, finishedOrders, shopResults, numPage, rowsPerPage, shops, isAllShops) {
  const allTotalTabs = _.map(shopResults, result => result.totalShopTab);
  let total = 0;
  let totalCmd = 0;
  let totalMissedCmd = 0;
  const rowsCopy = [...allTotalTabs];
  if (isAllShops) {
    rowsCopy.forEach((e) => {
      const { totalPreviousCA } = e
      if (totalPreviousCA) {
        total = totalPreviousCA
      }
      totalCmd += finishedOrders ? finishedOrders.filter(i => i.statusLabel === ORDER_CANCELED_LABEL && i.shopId === e.shopId).length : 0;
      totalMissedCmd += finishedOrders ? finishedOrders.filter(i => (i.statusLabel === ORDER_SHOP_CANCELED_LABEL || i.statusLabel === ORDER_MISSED_LABEL) && i.shopId === e.shopId).length : 0;
    });

    const totalCurrentCA = seedData[0]?.cost;
    const rate = total === 0 ? 0 : ((((totalCurrentCA - total) / total) * 100));
    rowsCopy.push({
      name: 'Total',
      nbCmd: seedData[3]?.cost,
      moy: seedData[4]?.cost,
      canceledCmd: totalCmd,
      missedCmd: totalMissedCmd,
      rate: rate,
      CA: seedData[0]?.cost,
      shopId: 'total'
    });
  }

  _.map(rowsCopy, e => {
    if (e.name !== 'Total') {
      e.canceledCmd = finishedOrders ? finishedOrders.filter(i => i.statusLabel === ORDER_CANCELED_LABEL && i.shopId === e.shopId).length : 0;
      e.missedCmd = finishedOrders ? finishedOrders.filter(i => (i.statusLabel === ORDER_SHOP_CANCELED_LABEL || i.statusLabel === ORDER_MISSED_LABEL) && i.shopId === e.shopId).length : 0;
      e.name = shops[e.shopId]?.name || e.shopId;
    }
  }).slice(numPage * rowsPerPage, numPage * rowsPerPage + rowsPerPage);

  return rowsCopy;
}
